import React, { Component } from 'react'
import { DialogButton } from '../Modal/Modal'
import { Spinner } from '../Loaders/Loaders'
import ReactMarkdown from 'components/Markdown/Markdown'
import { REQUEST_RECORD_ACCESS, GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS } from '../../requests'

const PIN_REQUEST_DESCRIPTION = process.env.PIN_REQUEST_DESCRIPTION;

export default class RequestOwnership extends Component{
  constructor(){
    super()
    this.state = {
      requestSuccessful: null,
      hasRequested: null
    }
  }
  componentDidMount = () => {
    GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS(this.props.category, this.props.source_id, hasRequested => {
      this.setState({hasRequested})
    })
  }
  requestAccess = () => {
    REQUEST_RECORD_ACCESS(this.props.category, this.props.source_id, successful => {
      if(successful){
        this.setState({requestSuccessful: true})
        // window.setTimeout(this.props.onRequestModalClose, 3000)
      }else{
        this.setState({requestSuccessful: false})
      }
    })
  }
  render(){
    return(
      <div className='request-ownership'>
        {
          this.state.requestSuccessful !== true && this.state.hasRequested === false &&
          <div>
            <div className='row'>
              <div className='col-12'>
                <p className='center-text'>
                  {
                    PIN_REQUEST_DESCRIPTION ?
                    <ReactMarkdown source={PIN_REQUEST_DESCRIPTION} className="markdown" />
                    :
                    <span>To become an owner of this record, a current owner will need to grant you access. To request access, click <strong>Request Access</strong> below.</span>
                  }
                </p>
              </div>
            </div>
            <div className='row margin-top'>
              <div className='col-12 button-column'>
                <DialogButton label='Request Access' className='btn-raised' customClickHandler onClick={this.requestAccess} />
              </div>
            </div>
            {
              this.state.requestSuccessful === false &&
              <div className='row margin-top'>
                <div className='col-12 button-column'>
                  <p className='error'>
                    Something went wrong while trying to request access. Try again later.
                  </p>
                </div>
              </div>
            }
          </div>
        }
        {
          this.state.hasRequested === null &&
          <div className='loader-wrapper'>
            <Spinner themeColor='medium-neutral' size='small' />
          </div>
        }
        {
          this.state.hasRequested === true &&
          <div className='row'>
            <div className='col-12'>
              <p className='center-text'>
                You've already requested access to this record.
              </p>
            </div>
          </div>
        }
        {
          this.state.requestSuccessful === true &&
          <div className='row'>
            <div className='col-12'>
              <p className='center-text error success'>
                <span className='icon icon-circle-check'/> You've successfully requested access to this record.
              </p>
            </div>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MyRecords/RequestOwnership.js